import { useMutation, UseMutationOptions } from 'react-query';
import { AxiosResponse, AxiosError } from 'axios';
import httpClient from 'utils/httpClient';
import { Session } from 'services/session';
import { SlotTimeSelectedType } from 'configs/types';

const SESSION_ISSUE_ABSENT = (
  courseId: number | undefined,
  sessionId: number | undefined,
) => `/v2/course/${courseId}/session/${sessionId}/issue`;

export type CancelSessionBody = {
  courseId: number | undefined;
  sessionId: number | undefined;
  _absent: number;
  content: string;
  schedules?: SlotTimeSelectedType[];
};

export type CancelSessionResponse = {
  sessions: Session;
};

export const cancelSession = ({
  courseId,
  sessionId,
  _absent,
  content,
  schedules,
}: CancelSessionBody) => {
  console.log('schedules', schedules);

  return httpClient.post<CancelSessionResponse>(
    SESSION_ISSUE_ABSENT(courseId, sessionId),
    {
      _absent,
      content,
      schedules: schedules
        ? schedules.map(schedule => ({
            date_time_from: schedule.timeFrom,
            date_time_to: schedule.timeTo,
          }))
        : undefined,
    },
  );
};

export const useCancelSession = (
  opts?: UseMutationOptions<
    AxiosResponse<CancelSessionResponse>,
    AxiosError<any>,
    CancelSessionBody
  >,
) =>
  useMutation<
    AxiosResponse<CancelSessionResponse>,
    AxiosError<any>,
    CancelSessionBody
  >(cancelSession, opts);
